import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';
import { BulkAssignServiceRequestsProps } from './types';

type UnassignServiceRequestsFromUserParams = {
  agentFirmId: string;
  userId: string;
  data: BulkAssignServiceRequestsProps;
};

export async function unassignServiceRequestsFromUser({
  agentFirmId,
  userId,
  data,
}: UnassignServiceRequestsFromUserParams) {
  const response = await fetcher(
    `${API_BASE_PATH}/${agentFirmId}/users/${userId}/bulk/unassign`,
    {
      method: 'POST',
      body: data,
    }
  );

  if (!response.ok) {
    const responseData = await response.json();
    return {
      success: false,
      error:
        responseData?.message ||
        'Failed to unassign service requests from user',
      statusCode: response.status,
    };
  }

  return {
    success: true,
  };
}
